import React from 'react';
import PropTypes from 'prop-types';
import AsyncSelect from 'react-select/lib/Async';
import { injectIntl } from 'react-intl';

const div = document.createElement('div');

const InputAsyncMulti = ({ intl, values, search, onChange }) => {
  const initialValue = values.map((value) => {
    div.innerHTML = value; // to convert start_text/end_text from html to plain text
    return { value, label: div.innerText };
  });

  return (
    <AsyncSelect
      openMenuOnClick={false}
      isClearable={false}
      isMulti
      loadOptions={(searchString, callback) => search(searchString).then(({ records }) => {
        callback(records ? records.map((record) => {
          div.innerHTML = `${record.first_name} ${record.last_name}`;
          return { value: record.id, label: div.innerText };
        }) : []);
      })}
      defaultValue={initialValue}
      placeholder={intl.formatMessage({ id: 'overall_input_search' })}
      onChange={(callbackValues) => {
        const newValues = callbackValues.map(({ value }) => value);
        if (newValues.join('_') !== initialValue.join('_')) onChange(newValues);
      }}
      noOptionsMessage={() => intl.formatMessage({ id: 'chats_search_noOptions' })}
      loadingMessage={() => intl.formatMessage({ id: 'chats_search_loading' })}
    />
  );
};

InputAsyncMulti.propTypes = {
  intl: PropTypes.objectOf(PropTypes.any),
  values: PropTypes.arrayOf(PropTypes.string),
  search: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default injectIntl(InputAsyncMulti);



// WEBPACK FOOTER //
// ./src/views/_Chats/_InputAsyncMulti.js